<template>
  <div class="DataTables QuickViewTableComponent ">
  
    <p v-if="isAssembly">{{lang.infotext_2}}:</p>
    <div v-if="isData && isAssembly" :id="idAssembly"></div>

    <p>{{lang.infotext_1}}: {{selectedGenericPart}}</p>
    <div v-if="isData" :id="id"></div>

      <LoaderComponent  v-if="!isData"></LoaderComponent>
      
    </div>
</template>
<script>
  import LoaderComponent from "@/components/shared/LoaderComponent"
  import LibraryTypes from '@/constants/LibraryTypes'
  import PartPropertiesType from '@/constants/PartPropertiesType'
  import LibraryPropertiesType from '@/constants/LibraryPropertiesType'

  import $ from 'jquery';
  import dt from 'datatables.net-bs4';
  import { mapGetters } from 'vuex';
  import * as Json2Svg from '@/Tools/json2svg';
  //import TclAPI from './../../Tools/tclAPI'
  //tclAPI = window.tclAPI;
  //require("./../../Tools/svg")
  


    export default {
        name: "QuickViewTableComponent",
        props:{
          lang: Object,
          parent: String,
        },
        components: {

          LoaderComponent
        },
        data () {
            return {
              name: "QuickViewTableComponent",
              mainTable: "",
              mainTableAssembly: "",
              currentPackage: 0,
              currentHDLPackage: 0,
              packages: [],
              packagesHDL: [],
              symbolSvg: {},
              place: "",
              placeHDL: "",
              currentSymbolObject: {
                name: "",
                type: "",
                partRevisionId: "",
              },
              currentHDLSymbolObject: {
                name: "",
                type: "",
                partRevisionId: ""
              },
              libraryType: "",
              lockedRevisionId: "",
              imageTrig: false,
              symbolTrig: false,
              symbolHDLTrig: false,
              footprintTrig: false,
              mpn_image: "",
              symbolIsActive: false,
              
            }
        },
        computed: {
          ...mapGetters([
          
            'appConf',
            'isPlugin',
            'globalSettings'
          ]),
          reloadedAfterAction(){
              return this.$store.getters.reloadedAfterAction;
          },
          id(){
            let id = "quickViewTable";
            if (this.parent == "Search"){
              id = id + "_Search";

            }
            if (this.parent == "modalSearchParts") {
              id = id + "_modalSearchParts";

            }
            return id;
          },
          idAssembly(){
            let id = "quickViewTableAssembly";
            if (this.parent == "Search"){
              id = id + "_Search";

            }
            if (this.parent == "modalSearchParts") {
              id = id + "_modalSearchParts";

            }
            return id;
          },
          selectedGenericPart(){
            let pm = ""; 
            if (this.parent == "modalSearchParts") {
              if (this.$store.getters.selectedSearchPartRows != null) {
                return this.$store.getters.selectedSearchPartRows.partNumber;
              } 
              

            } 
            let m = "part number";
            if (this.$store.getters.sectionPrefix == "lm"){
              m = "library number";
            }
            for (let prop in this.$store.getters.selectedRows[0]){
              
              if (this.$store.getters.selectedRows[0][prop].type == m){
                pm = this.$store.getters.selectedRows[0][prop].value.display;
                break;
              }
            }    

            return pm;
          },
          revisionId(){

            let revisionId = "";

            if (this.parent == "modalSearchParts") {
              
              if (this.$store.getters.selectedSearchPartRows != null) {
                return this.$store.getters.selectedSearchPartRows.revisionId;
              } else {
                return "";
              }
            }
            if (this.$store.getters.selectedRows.length != 0){
              revisionId = this.$store.getters.selectedRows[0].col___revisionId.revisionId;
              
              
            }
            return revisionId;

          },
          partId() {
            if (this.parent == "modalSearchParts") {
              
              if (this.$store.getters.selectedSearchPartRows != null) {
                return this.$store.getters.selectedSearchPartRows.partId;
              } else {
                return null;
              }
            }
         
            if (this.$store.getters.selectedRows.length > 0 && this.$store.getters.selectedRows[0].col___revisionId.partId != undefined) {
              return this.$store.getters.selectedRows[0].col___revisionId.partId;
            }
            return null;
          },
          isAssembly(){
            if (this.$store.getters.sectionPrefix == "projm"){
              return false;
            }
            if (this.parent == "modalSearchParts") {
              
              if (this.$store.getters.selectedSearchPartRows != null) {
                return this.$store.getters.selectedSearchPartRows.assembly;
              }
            } else {
              if (this.$store.getters.selectedRows.length != 0) {
                return this.$store.getters.selectedRows[0].col___status.assembly;
              }
            }
            
            return false;
          },
          isData(){

            return this.revisionId != undefined && this.revisionId != "";

          },
          
          variant(){
            if (this.$store.getters.s_skinVariant == "dark"){
              return "light";
            }else{
              return "dark";
            }
            
          },
          

        },
  created() {

          const obj = {
            currentSymbolName: undefined,
            currentPackage: undefined,
            isActive: false
          }

          this.$store.dispatch("setCurrentSymbol", obj);
          
          this.buildView();
          

          

        },
        watch: {
          reloadedAfterAction: function(newValue, oldValue){

        
            if (newValue.name == this.name){
                if (newValue.status == true){
                    
                    this.buildView();
                    
                    newValue.status = false;
                    newValue.name = "";
                    this.$store.dispatch("reloadAfterAction", newValue);
                }
            }
              
          },
          revisionId: function (newVal) {

          const objSym = {
            currentSymbolName: undefined,
            currentPackage: undefined,
            isActive: false
          }

          this.$store.dispatch("setCurrentSymbol", objSym);
            
            let vue = this;

            

            let obj1 ={
              assemblyRevisionId: newVal
            }
            let obj ={
              revisionId: newVal
            }
            if (this.$store.getters.sectionPrefix == "projm"){
              
              obj ={
                revisionId: newVal
                
              }
            }
            

            if (this.isAssembly  == true){
              this.$store.dispatch("getAssemblyElements", obj1)
              .then(function(result) {
                
                console.log(result)

                vue.prepareDataAssembly(result.data)

              })
            }

            let sectionPrefix = this.$store.getters.sectionPrefix;
            if (this.parent == "modalSearchParts") {
              sectionPrefix = "pm";

              obj.revisionId = this.revisionId;
                
              
            } 
            
            if (obj.revisionId === undefined || obj.revisionId === "") {

              return
            }
            
            this.$store.dispatch(sectionPrefix + "_getQuickView", obj)
            .then(function(result) {
              
              console.log(result)

              if (result.status == "OK"){



                result.data.sort(function (a, b) { return a.priority - b.priority });

                

                let data = result.data;

                if (sectionPrefix == "pm") {
                  let objPh = {
                    partId: vue.partId
                  }

                  

                  vue.$store.dispatch(sectionPrefix + "_getPhysicals", objPh)
                    .then(function (result) {
                      
                      if (result.data.length > 0) {
                        vue.mpn_image = result.data[0].imageUrl;

                        
                        if ((result.data[0].imageUrl.indexOf("http://") != -1) || (result.data[0].imageUrl.indexOf("https://") != -1)) {
                          let obj = {
                            id: 0,
                            priority: 0,
                            name: "MPN image",
                            type: "mpn_image",
                            value: {
                              display: result.data[0].imageUrl
                            }
                          }
                          data.unshift(obj);
                        }
                        
                      } else {
                        vue.mpn_image = "";
                      }

                      vue.prepareData(data);

                    })
                } else {
                  vue.prepareData(data);
                }

              } else {
                vue.prepareData([]);
              }

            })
            
            

          },
          currentPackage: function(newVal, oldVal){

            

            let barValue = document.getElementById("barValue");
            if (barValue != null){
              let index = this.currentPackage + 1;
              barValue.value = this.packages[this.currentPackage] + " (" + index + "/" + this.packages.length +")";
              
              let leftbar = document.getElementById("leftbar_" + this.id);
              let rightbar = document.getElementById("rightbar_" + this.id);

              if (this.currentPackage == 0){
                leftbar.disabled = true;
              }else{
                leftbar.disabled = false;
              }
              
              if (this.currentPackage == this.packages.length - 1){
                rightbar.disabled = true;
              }else{
                rightbar.disabled = false;
              }

                          
              
              for (var i = 0, le = this.packages.length; i < le; i++) {
                  var layer = "PACKAGES_"+this.packages[i];

                  if (i == this.currentPackage) {
                      if (this.place.getElementsByClassName(layer)[0] != undefined) {
                          this.place.getElementsByClassName(layer)[0].style["visibility"] = "visible";
                      }
                      

                  } else {
                      if (this.place.getElementsByClassName(layer)[0] != undefined) {
                          this.place.getElementsByClassName(layer)[0].style["visibility"] = "hidden";
                      }
                  }


              }
            }

            const obj = {
              currentSymbolName: this.currentSymbolObject.name,
              currentPackage: this.packages[this.currentPackage],
              isActive: this.symbolIsActive
            }
            
            this.$store.dispatch("setCurrentSymbol", obj);
            
          },
          currentHDLPackage: function (newVal, oldVal) {



            let barValue = document.getElementById("barHDLValue");
            if (barValue != null) {
              let index = this.currentHDLPackage + 1;
              barValue.value = this.packagesHDL[this.currentHDLPackage] + " (" + index + "/" + this.packagesHDL.length + ")";
              
              let leftbar = document.getElementById("leftbarHDL_" + this.id);
              let rightbar = document.getElementById("rightbarHDL_" + this.id);

              if (this.currentHDLPackage == 0) {
                leftbar.disabled = true;
              } else {
                leftbar.disabled = false;
              }

              if (this.currentHDLPackage == this.packagesHDL.length - 1) {
                rightbar.disabled = true;
              } else {
                rightbar.disabled = false;
              }



              for (var i = 0, le = this.packagesHDL.length; i < le; i++) {
                var layer = "PACKAGES_" + this.packagesHDL[i];

                if (i == this.currentHDLPackage) {
                  if (this.placeHDL.getElementsByClassName(layer)[0] != undefined) {
                    this.placeHDL.getElementsByClassName(layer)[0].style["visibility"] = "visible";
                  }


                } else {
                  if (this.placeHDL.getElementsByClassName(layer)[0] != undefined) {
                    this.placeHDL.getElementsByClassName(layer)[0].style["visibility"] = "hidden";
                  }
                }


              }
            }

            const obj = {
              currentHDLSymbolName: this.currentHDLSymbolObject.name,
              currentHDLPackage: this.packagesHDL[this.currentHDLPackage],
              
            }

            //this.$store.dispatch("setCurrentSymbol", obj);

          },
          
          currentSymbolObject: {
            handler: function(newVal){
              let vue = this;

            let idL = "libsymbolprop__" + vue.revisionId;

            const objL = {
              type: LibraryTypes.PART,
              name: newVal.name,
              idL: idL
            }
              
            this.$store.dispatch("lm_getIdOfActiveLibrary", objL)
              .then((result) => {
                console.log(result)
                if (result.data != null) {

                  if (result.data.status == "active") {
                    vue.symbolIsActive = true;
                  } else {
                    vue.symbolIsActive = false;
                  }

                  vue.loadLibraryProps(result.data, LibraryTypes.PART, vue.revisionId);


                } else {
                  vue.cleanLibraryProps(idL);
                }

              })
            },
            deep: true
          
            
          },
          currentHDLSymbolObject: {
            handler: function(newVal, oldVal){
              let vue = this;

              let idL = "libHDLsymbolprop__" + vue.revisionId;

              const objL = {
                type: LibraryTypes.HDLSYMBOL,
                name: newVal.name,
                idL: idL
              }
        
              this.$store.dispatch("lm_getIdOfActiveLibrary", objL)
                .then((result) => {
                  console.log(result)
                  if (result.data != null) {



                    vue.loadLibraryProps(result.data, LibraryTypes.HDLSYMBOL, vue.revisionId);


                  } else {
                    vue.cleanLibraryProps(idL);
                  }

                })
            },
            deep: true
          
            
          },
          
        },
        
        updated() {
                    
        },
        mounted: function () {

        },
        methods: {
          buildView(){
            
            let vue = this;
            

            let obj1 ={
              assemblyRevisionId: this.revisionId
            }
            let obj ={
              revisionId: this.revisionId
            }
            if (this.$store.getters.sectionPrefix == "projm"){
              obj ={
                revisionId: this.revisionId
              }
            }

            if (this.isAssembly  == true){
              this.$store.dispatch("getAssemblyElements", obj1)
              .then(function(result) {
                console.log(result)

                
                vue.prepareDataAssembly(result.data)

              })
            }

            let sectionPrefix = this.$store.getters.sectionPrefix;
            if (this.parent == "modalSearchParts") {
              sectionPrefix = "pm";

              obj = {
                revisionId: this.revisionId
              }

            }
            if (obj.revisionId === undefined || obj.revisionId === "") {

              return
            }
            
            this.$store.dispatch(sectionPrefix + "_getQuickView", obj)
            .then(function(result) {
              console.log(result)

              if (result.status == "OK"){

                result.data.sort(function (a, b) { return a.priority - b.priority });

                let data = result.data;

                if (sectionPrefix == "pm") {
                  let objPh = {
                    partId: vue.partId
                  }

                  

                  vue.$store.dispatch(sectionPrefix + "_getPhysicals", objPh)
                    .then(function (result) {
                      console.log(result.data)
                      if (result.data.length > 0) {
                        vue.mpn_image = result.data[0].imageUrl;

                        if ((result.data[0].imageUrl.indexOf("http://") != -1) || (result.data[0].imageUrl.indexOf("https://") != -1)) {
                          let obj = {
                            id: 0,
                            priority: 0,
                            name: "MPN image",
                            type: "mpn_image",
                            value: {
                              display: result.data[0].imageUrl
                            }
                          }
                          data.unshift(obj);
                        }
                      } else {
                        vue.mpn_image = "";
                      }

                      
                      
                      vue.prepareData(data);

                    })
                } else {
                  vue.prepareData(data);
                }
                

                
              }
              

            })
          },
          buildSymbolViewer(doc, place, revisionId){

            let vue = this;
            
            let svg  = doc.firstChild
            
            this.place = place;
            let barid = "bar_" + this.place.id;
            
            
            let symbolbar = document.getElementById(barid + "_" + this.id);
            
            if (symbolbar != null){
              symbolbar.innerHTML = "";
            
              let group = place.getElementsByTagName(`g`);
              
              this.packages = [];
              this.currentPackage = 0;
              for (let i = 0, lei = group.length; i < lei; i++){
                
                let temp = group[i].className.baseVal.split("_");
                if (temp[0] == "PACKAGES"){
                  this.packages.push(temp[1])
                }
              }
        
  
              if(this.packages.length > 1){
                
                this.symbolSvg = svg;

                
                
                
                
                let index = this.currentPackage + 1;
                let valueBar = this.packages[this.currentPackage] + " (" + index + "/" + this.packages.length +")";

                const bar = `<div role="group" class="input-group  input-group-sm">
                            <div class="input-group-prepend">
                            <button disabled="disabled" id="leftbar_`+ this.id + `" type="button" class="btn btn-sm btn-` + this.variant +` btn-bar">&lt;</button>
                            </div> 
                            <input type="text" disabled="disabled" class="form-control form-control-sm input-viewer" id="barValue" value="`+ valueBar +`" style="text-align:center;"> 
                            <div class="input-group-append">
                            <button id="rightbar_`+ this.id + `" type="button" class="btn btn-sm btn-` + this.variant +` btn-bar">&gt;</button>
                            </div>
                            </div>`;

                symbolbar.innerHTML = bar;

                let leftbar = document.getElementById("leftbar_" + this.id);
                leftbar.addEventListener("click", function(e) {
                  
                  if (vue.currentPackage == 0){
                    
                  }else{
                    
                    vue.currentPackage--;
                  }
                  
                })
                let rightbar = document.getElementById("rightbar_" + this.id);
                rightbar.addEventListener("click", function(e) {
                  
                  if (vue.currentPackage == vue.packages.length){
                    
                  }else{
                    
                    vue.currentPackage++;
                  }
                })

                


              }else{
                this.symbolSvg = {};
              }
            }
            

            if (this.$store.getters.sectionPrefix == "pm"){
              let place = "symbol_select_" + vue.id;
              
              
              let symbol_select = document.getElementById(place);
              
              symbol_select.addEventListener("change", function(e){
                
                let id = "symbol__" + vue.revisionId;
                if (vue.parent == "Search"){
                  id = "searchsymbol__" + vue.revisionId;
                }
                if (vue.parent == "modalSearchParts") {
                  id = "modalSearchPartssymbol__" + vue.revisionId;
                }

                vue.currentSymbolObject.name = this.value;

                let img = document.getElementById("symbol__" + vue.revisionId);
                if (img != null) {
                  img.dataset.name = this.value;
                }

                const obj = {
                  type: LibraryTypes.PART,
                  name: this.value,
                  id: id,
                  revisionId: vue.revisionId
                }
                
                
                  vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_getSvg", obj)
                  .then((result) => {
                    
                    if (result != null){
                      
                      let id = result.id;
                                                
                      vue.loadSVG(result, id, vue.revisionId);
                      
                      
                    }
                  
                  })
                

              })
            }
            

            const obj = {
              currentSymbolName: this.currentSymbolObject.name,
              currentPackage: this.packages[this.currentPackage],
              isActive: this.symbolIsActive
            }
            
            this.$store.dispatch("setCurrentSymbol", obj);

            

          },
          buildHDLSymbolViewer(doc, place) {

            let vue = this;

            let svg = doc.firstChild

            this.placeHDL = place;
            let barid = "bar_" + this.placeHDL.id;

            
            let symbolbar = document.getElementById(barid + "_" + this.id);
            
            if (symbolbar != null) {
              symbolbar.innerHTML = "";

              let group = place.getElementsByTagName(`g`);

              this.packagesHDL = [];
              this.currentHDLPackage = 0;
              for (let i = 0, lei = group.length; i < lei; i++) {

                let temp = group[i].className.baseVal.split("_");
                if (temp[0] == "PACKAGES") {
                  this.packagesHDL.push(temp[1])
                }
              }


              if (this.packagesHDL.length > 1) {

                this.symbolSvg = svg;





                let index = this.currentHDLPackage + 1;
                let valueBar = this.packagesHDL[this.currentHDLPackage] + " (" + index + "/" + this.packagesHDL.length + ")";

                const bar = `<div role="group" class="input-group  input-group-sm">
                            <div class="input-group-prepend">
                            <button disabled="disabled" id="leftbarHDL_`+ this.id + `" type="button" class="btn btn-sm btn-` + this.variant + `">&lt;</button>
                            </div> 
                            <input type="text" disabled="disabled" class="form-control form-control-sm input-viewer" id="barHDLValue" value="`+ valueBar + `" style="text-align:center;"> 
                            <div class="input-group-append">
                            <button id="rightbarHDL_`+ this.id + `" type="button" class="btn btn-sm btn-` + this.variant + `">&gt;</button>
                            </div>
                            </div>`;

                symbolbar.innerHTML = bar;

                let leftbar = document.getElementById("leftbarHDL_" + this.id);
                leftbar.addEventListener("click", function (e) {

                  if (vue.currentHDLPackage == 0) {

                  } else {

                    vue.currentHDLPackage--;
                  }

                })
                let rightbar = document.getElementById("rightbarHDL_" + this.id);
                rightbar.addEventListener("click", function (e) {

                  if (vue.currentHDLPackage == vue.packagesHDL.length) {

                  } else {

                    vue.currentHDLPackage++;
                  }
                })




              } else {
                this.symbolSvg = {};
              }
            }


            if (this.$store.getters.sectionPrefix == "pm") {
              let place = "hdlsymbol_select_" + vue.id;


              let hdlsymbol_select = document.getElementById(place);

              hdlsymbol_select.addEventListener("change", function (e) {

                let id = "HDLsymbol__" + vue.revisionId;
                if (vue.parent == "Search") {
                  id = "searchsymbol__" + vue.revisionId;
                }
                if (vue.parent == "modalSearchParts") {
                  id = "modalSearchPartssymbol__" + vue.revisionId;
                }

                vue.currentHDLSymbolObject.name = this.value;
                //vue.currentHDLSymbolName = this.value;

                let img = document.getElementById("HDLsymbol__" + vue.revisionId);
                if (img != null) {
                  img.dataset.name = this.value;
                }

                const obj = {
                  type: LibraryTypes.HDLSYMBOL,
                  name: this.value,
                  id: id,
                  revisionId: vue.revisionId
                }


                vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_getSvg", obj)
                  .then((result) => {

                    if (result != null) {

                      let id = result.id;

                      vue.loadSVG(result, id, vue.revisionId);


                    }

                  })


              })
            }


            const obj = {
              currentHDLSymbolName: this.currentHDLSymbolName,
              currentHDLPackage: this.packagesHDL[this.currentHDLPackage],

            }

            //this.$store.dispatch("setCurrentSymbol", obj);

          },
          async loadSVG(blob, id, revisionId){

            let svgData = await new Response(blob).text();
            
            let place = document.getElementById(id);
            if (place != null){
              place.innerHTML = "";

              var parser = new DOMParser();
              var doc = parser.parseFromString(svgData, "image/svg+xml");
              doc.documentElement.setAttribute("width", 200);
              doc.documentElement.setAttribute("height", 200);
                    
              place.appendChild(doc.documentElement);
              
              if (place.dataset.type == LibraryTypes.PART || place.dataset.type == LibraryTypes.SYMBOL ) {

                this.buildSymbolViewer(doc, place, revisionId);
              }
              if (place.dataset.type == LibraryTypes.HDLSYMBOL) {

                this.buildHDLSymbolViewer(doc, place, revisionId);
              }

              

              //let pos = id.indexOf("symbol");
            
              // if (pos > -1){
              
              //   this.buildSymbolViewer(doc, place);
              // }
              // pos = id.indexOf("hdlsymbol");

              // if (pos > -1) {

              //   this.buildHDLSymbolViewer(doc, place);
              // }
            }
            
          },
          async loadLibraryProps(data, type, partRevisionId) {
            
            let vue = this;
            const obj = {
              revisionId: data.revisionId
            }

            this.$store.dispatch("lm_getLibrary", obj)
            .then((result) => {


                console.log(result.data)

              if (result.status == "OK") {

                let libraryType = "";

                for (let i = 0, lei = result.data.length; i < lei; i++) {
                  if (result.data[i].type == LibraryPropertiesType.LIBRARYTYPE) {
                    libraryType = result.data[i].value.display;
                  }
                }

                if (type == LibraryTypes.PART || type == LibraryTypes.SYMBOL) {
                  
                  let img = document.getElementById("symbol__" + vue.revisionId);
                  
                  if (img != null) {
                    img.dataset.type = libraryType;
                  }
                  
                }
            
                if (type == LibraryTypes.FOOTPRINT) {
                  vue.buildLibraryFootprintTable(result.data, data);
                }
                if (type == LibraryTypes.PART || type == LibraryTypes.SYMBOL || type == LibraryTypes.HDLSYMBOL) {
                  vue.buildLibrarySymbolTable(result.data, data);
                }
                  
                  
                }
            })
          },
          cleanLibraryProps(idL) {
            
            let place = document.getElementById(idL);
            if (place == null) {
              return
            }
            place.innerHTML = "";
          },
          buildLibraryFootprintTable(libraryData, status) {

            let place = document.getElementById(status.idL);
            if (place == null) {
              return
            }
            place.innerHTML = "";

            let str = "<table class=\"library-table\">";

            for (let i = 0, lei = libraryData.length; i < lei; i++) {
              let prop = libraryData[i];
              if (prop.type != "library number" && prop.type != "library type" && prop.type != "image"){
                if (prop.name != null) {
                  str += "<tr class=\"prop-tr\">";
                  let value = "";
                  if (prop.value != null) {
                    value = prop.value.display;
                  } else {
                    value = "";
                  }
                  str += "<td>" + prop.name + "</td><td>" + value + "</td>";

                  str += "</tr>";
                }
            }
            }

            str += "</table>";

            place.innerHTML = str;
            
          },
          buildLibrarySymbolTable(libraryData, status) {

            let place = document.getElementById(status.idL);
            if (place == null) {
              return
            }
            place.innerHTML = "";

            let str = "<table class=\"library-table\">";

            for (let i = 0, lei = libraryData.length; i < lei; i++) {
              let prop = libraryData[i];
              if (prop.type != "library number" && prop.type != "library type" && prop.type != "image") {
                if (prop.name != null) {
                  str += "<tr class=\"prop-tr\">";
                  let value = "";
                  if (prop.value != null) {
                    value = prop.value.display;
                  } else {
                    value = "";
                  }
                  str += "<td>" + prop.name + "</td><td>" + value + "</td>";

                  str += "</tr>";
                }
              }
            }

            str += "</table>";

            place.innerHTML = str;

          },
          prepareData(data){

            for (let i = 0, lei = data.length; i < lei; i++){
              if (data[i].value == null){
                data[i].value = {
                  display: "",
                  filter: "",
                  sort: ""
                }
              }
              
              if (data[i].type == "library type"){
                this.libraryType = data[i].value.display;
              }
              
            }

            
            

            this.buildTable(data)


          },
          prepareDataAssembly(data){

            
            this.buildTableAssembly(data)


          },
          pinsToggle() {

            let vue = this;
            let checkboxPinOptions = document.getElementsByClassName('checkboxPinOption');
            

            for (var i = 0; i < checkboxPinOptions.length; i++) {
              checkboxPinOptions[i].addEventListener('click', function () {
                
                let svg = document.getElementById("symbol__" + vue.revisionId);
                
                const pinsNameslayers = svg.querySelectorAll('[class="PINS_NAMES"]')
                
                const pinsNumberlayers = svg.querySelectorAll('[class="PINS_NUMBERS"]')
                
                if (this.checked == true) {
                  for (let i = 0, lei = pinsNumberlayers.length; i < lei; i++){
                    pinsNumberlayers[i].style.display = "none";
                  }
                  for (let i = 0, lei = pinsNameslayers.length; i < lei; i++) {
                    pinsNameslayers[i].style.display = "block";
                  }
                  
                  
                } else {
                  for (let i = 0, lei = pinsNumberlayers.length; i < lei; i++) {
                    pinsNumberlayers[i].style.display = "block";
                  }
                  for (let i = 0, lei = pinsNameslayers.length; i < lei; i++) {
                    pinsNameslayers[i].style.display = "none";
                  }
                  
                  
                }
                

              })
            }
          },
          buildTable(_dataTable){
            this.imageTrig = false;
            this.symbolTrig = false;
            this.symbolHDLTrig = false;
            this.footprintTrig = false;
            
            var tableplace = document.getElementById(this.id);

            if (tableplace == null){
              return;
            }

            while (tableplace.firstChild) {
                tableplace.removeChild(tableplace.firstChild);
            }

            var table = document.createElement("table");
            table.setAttribute("id", "t_"+this.id);
            table.setAttribute("class", "table table-striped table-bordered");
            
            tableplace.appendChild(table)

            var tr = document.createElement("tr");
            tr.setAttribute("class", "cellHeader");
            var thead = document.createElement("thead");
            thead.appendChild(tr);
            table.appendChild(thead);

            var _vue = this;

            let cols =  [
              { "data": "id" },
              { "data": "priority" },
              { "data": "name" },// render: $.fn.dataTable.render.text() },
              { "data": "value" },

            ]

            let columns = [
              {
                name: "Id",
                alignInColumn: "left",

              },
              {
                name: "Priority",
                alignInColumn: "left",

              },
              {
                name: this.lang.table_header_Name,
                alignInColumn: "left",

              },
              {
                name: this.lang.table_header_Value,
                alignInColumn: "left",

              },

            ]

            var header = "";
            var columnDefs = [];
            var len = columns.length;
            let trigSymbol = false;
            let trigHDLSymbol = false;
            let trigFootprint = false;
            for (var i = 0; i < len; i++){

              let classname = '_dt-body-'+ columns[i].alignInColumn;

              let  el = {
                  targets: i,
                  className: classname,
                  render: function ( data, type, row, meta ) {
                    
                    if (data == null){
                      data = "";
                    }
                    
                    data = $.fn.dataTable.render.text().display(data);
                    if (data.display != undefined) {
                      data.display = $.fn.dataTable.render.text().display(data.display);
                    }
                                        
                    if (meta.col == 0){
                      return data;
                    }
                    if (meta.col == 1){
                      return data;
                    }
                    if (meta.col == 2){
                      let ln = "";
                      let button = "";
                      if (row.type == "symbol"){
                        let value = row.value.display.split(",");
                        if (value.length > 1){
                          ln = " (" + value.length + ")";
                        }
                        if (_vue.isAssembly  != true){
                          if(_vue.isPlugin&&!_vue.appConf.status.isLM){
                            button = "<br><br><button class=\"btn btn-sm btn-"+_vue.variant+" button_symbol_create_svg\" id=\"button_symbol_create_svg\" data-elements=\""+row.value.display+"\" >"+_vue.lang.button_CreateSvg+"</button>";
                          }
                        }
                        
                      }
                      if (row.type == "footprint"){
                        let value = row.value.display.split(",");
                        if (value.length > 1){
                          ln = " (" + value.length + ")";
                        }
                        
                        if (_vue.isAssembly  != true){
                          if(_vue.isPlugin&&!_vue.appConf.status.isLM){
                            button = "<br><br><button class=\"btn btn-sm btn-"+_vue.variant+" button_footprint_create_svg\" id=\"button_footprint_create_svg\" data-elements=\""+row.value.display+"\" >"+_vue.lang.button_CreateSvg+"</button>";
                          }
                        }
                        
                      }
                      // if (row.type == "image"){
                      //   console.log(_vue.isPlugin,_vue.appConf.status.isLM)
                      //   if(_vue.isPlugin&&_vue.appConf.status.isLM){
                      //      button = "<br><br><button class=\"btn btn-sm btn-"+_vue.variant+" button_footprint_create_svg\" id=\"button_" + _vue.libraryType + "_create_svg\" data-elements=\""+row.value.display+"\" >"+_vue.lang.button_CreateSvg+"</button>";
                      //   }
                        
                      // }
                      
                      return data + ln + "<br>" + button;
                    }
                    if (meta.col == 3){
                                      
                      
                      if (row.type == "part number"){

                        return data.display;
                      }
                      if (row.type == "library number"){

                        return data.display;
                      }
                      if (row.type == "library type"){

                        return data.display;
                      }
                      if (row.type == "number of pins"){

                        return data.display;
                      }
                      if (row.type == "number of mech pins"){

                        return data.display;
                      }
                      if (row.type == "project number"){

                        return data.display;
                      }
                      if (row.type == "project name") {

                return data.display;
              }
                      if (row.type == "project type"){

                        return data.display;
                      }
                      if (row.type == "image"){
                        
                        if (_vue.libraryType == LibraryTypes.PADSTACK) { 
                          return "<img src=\"/static/noimage_pads.svg\" class=\"image-footprint\">";
                        }
                        if (data.display == ""){
                          return "<img src=\"/static/noimage.svg\" class=\"image-footprint\">";
                        }
                        let bar = "";
                        let pinOption = "";
                        
                        let id = "library__"+_vue.revisionId;
                        if (_vue.libraryType == LibraryTypes.PART || _vue.libraryType == LibraryTypes.SYMBOL){
                          if (_vue.parent == "Search") {
                            id = "searchsymbol__" + _vue.revisionId;
                          } else if (_vue.parent == "modalSearchParts"){
                            id = "modalSearchPartssymbol__" + _vue.revisionId;
                          }else{
                            id = "symbol__"+_vue.revisionId;
                          }
                          
                          let barid = "bar_symbol__"+_vue.revisionId + "_" + _vue.id;
                          bar = "<div id=\"" + barid + "\" class=\"bar-symbol\"></div>";
                          pinOption = "<input class=\"checkboxPinOption\" type=\"checkbox\" value=\"\"> " + _vue.lang.label_pinSwitch;
                        }
                        if (_vue.libraryType == LibraryTypes.HDLSYMBOL) {
                          if (_vue.parent == "Search") {
                            id = "searchsymbol__" + _vue.revisionId;
                          } else if (_vue.parent == "modalSearchParts") {
                            id = "modalSearchPartssymbol__" + _vue.revisionId;
                          } else {
                            id = "symbol__" + _vue.revisionId;
                          }

                          let barid = "bar_symbol__" + _vue.revisionId + "_" + _vue.id;
                          bar = "<div id=\"" + barid + "\" class=\"bar-symbol\"></div>";
                        }
                        if (_vue.libraryType == LibraryTypes.FOOTPRINT || _vue.libraryType == LibraryTypes.MECHANICAL){
                            if (_vue.parent == "Search"){
                              id = "searchfootprint__" + _vue.revisionId;
                            } else if (_vue.parent == "modalSearchParts") {
                              id = "modalSearchPartsfootprint__" + _vue.revisionId;  
                            }else{
                              id = "footprint__"+_vue.revisionId;
                            }
                            
                            
                          }
                          
                          
                          let image = "<div id=\""+id+"\" data-revisionid=\""+_vue.revisionId+"\" data-name=\""+data.display+"\" data-type=\""+_vue.libraryType+"\" class=\"image-zoom image-footprint\"></div>" + bar + pinOption;


                          const obj = {
                            type:  _vue.libraryType,
                            name: data.display,
                            id: id,
                            revisionId: _vue.revisionId
                          }
                          
                          if (data.display != ""){
                            if(_vue.imageTrig === false){
                              _vue.imageTrig = true;

                              let sectionPrefix = _vue.$store.getters.sectionPrefix;
                              if (_vue.parent == "modalSearchParts") {
                                sectionPrefix = "pm";

                              }

                              _vue.$store.dispatch(sectionPrefix + "_getSvg", obj)
                              .then((result) => {
                                
                                if (result != null){
                                  
                                  
                                  let id = result.id;                          
                                  _vue.loadSVG(result, id, _vue.revisionId);
                                  
                                  
                                }
                              
                              })
                            }
                            
                          }else{
                            image = data.display;
                          }
                                                  
                          return image;
                      }
                      if (row.type == "mpn_image") {
                        if ((data.display.indexOf("http://") != -1) || (data.display.indexOf("https://") != -1)) {

                          return "<img class=\"img-thumbnail img-fluid\" height='40px' src='" + data.display + "'>";
                        }
                        return ""
                      }
                      if (row.type == "text"){

                        return data.display;
                      }
                      if (row.type == "link") {

                        if (data.display != null) {
                          let link = data.display;
                          let pos = -1;
                          if (_vue.globalSettings.displayHttpLinks == true) {

                            pos = link.indexOf("http");

                            if (pos > -1) {
                              return "<a href='" + link + "' target='_blank'>Link</a>";
                            }
                          }
                          if (_vue.globalSettings.displayLocalLinks == true) {
                            pos = link.indexOf("\\\\");
                            if (pos > -1) {

                              link = link.split('\\').join('/');

                              link = "file:///" + link
                              return "<a href='" + link + "' target='_blank'>Local link</a>";
                            }
                            pos = link.indexOf("file://");
                            if (pos > -1) {

                              return "<a href='" + link + "' target='_blank'>Local link</a>";
                            }
                          }


                        } else {
                          return "";
                        }
                      }
                      
                      if (row.type == "comment"){

                        return data.display;
                      }
                      
                      if (row.type == PartPropertiesType.SYMBOL){
                       
                        if (trigSymbol == false){

                          let symbols = data.display.split(",");
                          let place = "symbol_select_" + _vue.id;
                          
                          let select = "<select data-type=\""+ row.type +"\" class=\"form-control input-props symbol_select\" id=\"" + place +"\">";
                          for (let j = 0, lej = symbols.length; j < lej; j++){
                            let selected = "";
                            if (j == 0){
                              selected = "selected=\"selected\"";
                              _vue.currentSymbolObject.name = symbols[j].trim();
                            }
                            
                            select += "<option value=\""+symbols[j].trim()+"\" " + selected + ">" + symbols[j].trim() + "</option>";
                          }
                          select += "</select>";


                          

                          let id = "symbol__"+_vue.revisionId;
                          if (_vue.parent == "Search"){
                              id = "searchsymbol__"+_vue.revisionId;
                          }
                          if (_vue.parent == "modalSearchParts") {
                            id = "modalSearchPartssymbol__" + _vue.revisionId;
                          }
                          let idL = "libsymbolprop__" + _vue.revisionId;
                          let barid = "bar_symbol__"+_vue.revisionId + "_" + _vue.id;
                          trigSymbol = true;

                          let pinOption = "<input class=\"checkboxPinOption\" type=\"checkbox\" value=\"\"> " + _vue.lang.label_pinSwitch;

                          let image = select + "<br><div id=\"" + id + "\" data-revisionid=\"" + _vue.revisionId + "\" data-name=\"" + symbols[0] + "\" data-type=\"symbol\" class=\"image-zoom image-symbol\"></div><div id=\"" + barid + "\" class=\"bar-symbol\"></div>"+ pinOption +"<div id=\"" + idL + "\" data-revisionid=\"" + _vue.revisionId + "\" data-name=\"" + data.display +"\" data-type=\""+ row.type+"\" class=\"\"></div>";

                        
                          const obj = {
                            type: LibraryTypes.PART,
                            name: symbols[0],
                            id: id,
                            revisionId: _vue.revisionId
                          }
                          
                          if (symbols[0] != ""){
                            if(_vue.symbolTrig === false){
                              _vue.symbolTrig = true;

                              let sectionPrefix = _vue.$store.getters.sectionPrefix;
                              if (_vue.parent == "modalSearchParts") {
                                sectionPrefix = "pm";

                                
                              }

                              _vue.$store.dispatch(sectionPrefix + "_getSvg", obj)
                              .then((result) => {
                                
                                if (result != null){
                                  
                                  let id = result.id;
                                                            
                                  _vue.loadSVG(result, id, _vue.revisionId);
                                  
                                  
                                }
                              
                              })

                              const objL = {
                                type: LibraryTypes.PART,
                                name: _vue.currentSymbolObject.name,
                                idL: idL
                              }
                              
                              _vue.$store.dispatch("lm_getIdOfActiveLibrary", objL)
                                .then((result) => {
                                  console.log(result)
                                  if (result.data != null) {

                                    if (result.data.status == "active") {
                                      _vue.symbolIsActive = true;
                                    } else {
                                      _vue.symbolIsActive = false;
                                    }
                                    _vue.loadLibraryProps(result.data, row.type);


                                  } else {
                                    _vue.cleanLibraryProps(idL);
                                  }

                                })
                            }
                          }else{
                            image = data.display;
                          }
                                            
                          return image;
                        }else{
                          
                        }
                        
                        
                                                
                      }
                      if (row.type == PartPropertiesType.HDLSYMBOL) {

                        if (trigHDLSymbol == false) {

                          let symbols = data.display.split(",");
                          //let symbol = data.display;
                          _vue.currentHDLSymbolName = symbols;
                          let place = "hdlsymbol_select_" + _vue.id;

                          let select = "<select class=\"form-control input-props hdlsymbol_select\" id=\"" + place + "\">";
                          for (let j = 0, lej = symbols.length; j < lej; j++) {
                            let selected = "";
                            if (j == 0) {
                              selected = "selected=\"selected\"";
                              _vue.currentHDLSymbolObject.name = symbols[j].trim();
                            }

                            select += "<option value=\"" + symbols[j].trim() + "\" " + selected + ">" + symbols[j].trim() + "</option>";
                          }
                          select += "</select>";


                          //  _vue.currentHDLSymbolObject.name = symbol;

                          let id = "HDLsymbol__" + _vue.revisionId;
                          if (_vue.parent == "Search") {
                            id = "searchsymbol__" + _vue.revisionId;
                          }
                          if (_vue.parent == "modalSearchParts") {
                            id = "modalSearchPartssymbol__" + _vue.revisionId;
                          }
                          let idL = "libHDLsymbolprop__" + _vue.revisionId;
                          let barid = "bar_HDLsymbol__" + _vue.revisionId + "_" + _vue.id;
                          trigHDLSymbol = true;
                          let image = select + "<br><div id=\"" + id + "\" data-revisionid=\"" + _vue.revisionId + "\" data-name=\"" + symbols[0] + "\" data-type=\"hdl symbol\" class=\"image-zoom image-symbol\"></div><div id=\"" + barid + "\" class=\"bar-symbol\"></div><div id=\"" + idL + "\" data-revisionid=\"" + _vue.revisionId + "\" data-name=\"" + data.display + "\" data-type=\"hdl symbol\" class=\"\"></div>";


                          const obj = {
                            type: row.type,
                            name: symbols[0],
                            id: id,
                            revisionId: _vue.revisionId
                          }

                          if (symbols[0] != "") {
                            if (_vue.symbolHDLTrig === false) {
                              _vue.symbolHDLTrig = true;

                              let sectionPrefix = _vue.$store.getters.sectionPrefix;
                              if (_vue.parent == "modalSearchParts") {
                                sectionPrefix = "pm";


                              }

                              _vue.$store.dispatch(sectionPrefix + "_getSvg", obj)
                                .then((result) => {

                                  if (result != null) {

                                    let id = result.id;

                                    _vue.loadSVG(result, id, _vue.revisionId);


                                  }

                                })

                              const objL = {
                                type: LibraryTypes.HDLSYMBOL,
                                name: _vue.currentHDLSymbolObject.name,//_vue.currentHDLSymbolName,
                                idL: idL
                              }
                      
                              _vue.$store.dispatch("lm_getIdOfActiveLibrary", objL)
                                .then((result) => {
                                  console.log(result)
                                  if (result.data != null) {



                                    _vue.loadLibraryProps(result.data, row.type);


                                  } else {
                                    _vue.cleanLibraryProps(idL);
                                  }

                                })
                            }
                          } else {
                            image = data.display;
                          }

                          return image;
                        } else {

                        }



                      }
                      if (row.type == PartPropertiesType.FOOTPRINT){

                        if (trigFootprint == false){
                          trigFootprint = true;
                          let id = "footprint__"+_vue.revisionId;
                          if (_vue.parent == "Search"){
                              id = "searchfootprint__"+_vue.revisionId;
                          }
                          if (_vue.parent == "modalSearchParts") {
                            id = "modalSearchPartsfootprint__" + _vue.revisionId;
                          }
                          let idL = "libfootprintprop__" + _vue.revisionId;
                          
                          let image = data.display + "<br><br><div id=\"" + id + "\" data-revisionid=\"" + _vue.revisionId + "\" data-name=\"" + data.display + "\" data-type=\"footprint\" class=\"image-zoom image-footprint\"></div><div id=\"" + idL + "\" data-revisionid=\"" + _vue.revisionId + "\" data-name=\"" + data.display +"\" data-type=\"footprint\" class=\"\"></div>";


                          const obj = {
                            type: row.type,
                            name: data.display,
                            id: id,
                            revisionId: _vue.revisionId
                          }
                          
                          if (data.display != ""){
                            if(_vue.footprintTrig === false){
                              _vue.footprintTrig = true;
                              let sectionPrefix = _vue.$store.getters.sectionPrefix;
                              if (_vue.parent == "modalSearchParts") {
                                sectionPrefix = "pm";

                              }
                              _vue.$store.dispatch(sectionPrefix + "_getSvg", obj)
                              .then((result) => {
                                
                                if (result != null){
                                  
                                  
                                  let id = result.id;                          
                                  _vue.loadSVG(result, id, _vue.revisionId);
                                  
                                  
                                }
                              
                              })

                              const objL = {
                                type: LibraryTypes.FOOTPRINT,
                                name: data.display,
                                idL: idL
                              }
                      
                              _vue.$store.dispatch("lm_getIdOfActiveLibrary", objL)
                                .then((result) => {
                                  console.log(result)
                                  if (result.data != null) {
                                    
                                    _vue.loadLibraryProps(result.data, row.type, _vue.revisionId);

                                  } else {
                                    _vue.cleanLibraryProps(idL);
                                  }

                                })
                            }
                          }else{
                            image = data.display;
                          }
                                                  
                          return image;
                        }else{

                        }
                        
                        
                      } if (row.type == LibraryTypes.MECHANICAL){

                        if (trigFootprint == false){
                          trigFootprint = true;
                          let id = "footprint__"+_vue.revisionId;
                          if (_vue.parent == "Search"){
                              id = "searchfootprint__"+_vue.revisionId;
                          }
                          if (_vue.parent == "modalSearchParts") {
                            id = "modalSearchPartsfootprint__" + _vue.revisionId;
                          }
                          
                          let image = data.display + "<br><br><div id=\""+id+"\" data-revisionid=\""+_vue.revisionId+"\" data-name=\""+data.display+"\" data-type=\"mechanical\" class=\"image-zoom image-footprint\"></div>";


                          const obj = {
                            type: row.type,
                            name: data.display,
                            id: id,
                            revisionId: _vue.revisionId
                          }
                          
                          if (data.display != ""){
                            if(_vue.footprintTrig === false){
                              _vue.footprintTrig = true;
                              let sectionPrefix = _vue.$store.getters.sectionPrefix;
                              if (_vue.parent == "modalSearchParts") {
                                sectionPrefix = "pm";

                              }
                              _vue.$store.dispatch(sectionPrefix + "_getSvg", obj)
                              .then((result) => {
                                
                                if (result != null){
                                  
                                  
                                  let id = result.id;                          
                                  _vue.loadSVG(result, id, _vue.revisionId);
                                  
                                  
                                }
                              
                              })
                            }
                          }else{
                            image = data.display;
                          }
                                                  
                          return image;
                        }else{

                        }
                        
                        
                      }
                      if (row.type == "rohs"){

                        return data.display;
                      }
                      if (row.type == "date"){

                        return data.display;
                      }
                      if (row.type == "value"){

                        return data.display;
                      }

                      return data.display;
                    }

                  }
                }

                columnDefs.push(el);


              var th = document.createElement("th");
              tr.appendChild(th);
              var br = document.createElement("br");
              th.appendChild(br);

              var tx = document.createTextNode(columns[i].name)
              th.appendChild(tx);

            }


            var json = {};
            json.paging = false;
            json.info = false;
            json.dom = 'f<t>';
            json.data= _dataTable;
            json.myColumnFormats = columns;
            json.select = false;
            json.columns = cols;
            json.columnDefs = columnDefs;
            json.order = [1, "asc"];
            json.initComplete = function () {

              _vue.pinsToggle();
            
            
            }
            

            if ($.fn.dataTable.isDataTable("#t_"+this.id)) {
                this.mainTable.destroy();
                
            }



            this.mainTable = $('#t_'+this.id).DataTable(json);


            this.mainTable.columns.adjust().draw();

            //hide first column in table
            this.mainTable.column( 0 ).visible( false );
            this.mainTable.column( 1 ).visible( false );

            //search input change view
            var searchplace = document.getElementById("t_" + this.id + "_filter").firstChild

            while (searchplace.firstChild) {

              if (searchplace.firstChild.textContent == "Search:"){
                  searchplace.removeChild(searchplace.firstChild);
                  break;
              }

            }

            searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
            searchplace.firstChild.setAttribute("class", "form-control form-control-sm")

            if(_vue.isPlugin == true){

              let button_symbol_create_svg = document.getElementById("button_symbol_create_svg");
              if (button_symbol_create_svg != null){
                button_symbol_create_svg.addEventListener("click", function(e){
                  
                 
                  _vue.lockedRevisionId = _vue.$store.getters.selectedRows[0].col___revisionId.revisionId;
                  _vue.generateSVG(this.dataset.elements, "symbol");
                })
              }
              
              let button_footprint_create_svg = document.getElementById("button_footprint_create_svg");
               if (button_footprint_create_svg != null){
                button_footprint_create_svg.addEventListener("click", function(e){
                  
                  
                  _vue.lockedRevisionId = _vue.$store.getters.selectedRows[0].col___revisionId.revisionId;
                  _vue.generateSVG(this.dataset.elements, "footprint");
                })
               }

            }

            let image_zoom = document.getElementsByClassName("image-zoom");
            
            if (image_zoom != null){

              for (let i = 0, lei = image_zoom.length; i < lei; i++){
                image_zoom[i].addEventListener("click", function(e){
                  

                   

                  const svgObject = {
                    type: this.dataset.type,
                    name: this.dataset.name,
                    id: this.dataset.type + "__" + this.dataset.revisionid,
                    revisionId: this.dataset.revisionid
                  }

                  const langObj = {
                    modal_Title: this.dataset.name,
                    label_pinSwitch: _vue.lang.label_pinSwitch
                  }
                  
                  const obj = {
                    title: this.dataset.name,
                    text: "",
                    type: "zoom_svg",
                    buttons: 1,
                    buttonName: _vue.lang.modal_ZoomSvg.button_Close,
                    size: "xl",
                    lang: langObj,
                    funcNo: "",
                    funcYes: "",
                    funcCustom: "",
                    svgObject: svgObject
                  };
                  
                _vue.$store.dispatch("showModalComponent", obj);

                })

              }

            }

            

          },
          
          buildTableAssembly(_dataTable){
            

            let _vue = this;
            
            var tableplace = document.getElementById(this.idAssembly);

            if (tableplace == null){
              return;
            }

            while (tableplace.firstChild) {
                tableplace.removeChild(tableplace.firstChild);
            }

            var table = document.createElement("table");
            table.setAttribute("id", "t_"+this.idAssembly);
            table.setAttribute("class", "table table-striped table-bordered");
            
            tableplace.appendChild(table)

            var tr = document.createElement("tr");
            tr.setAttribute("class", "cellHeader");
            var thead = document.createElement("thead");
            thead.appendChild(tr);
            table.appendChild(thead);

            

            let cols =  [
              { "data": "revisionId" },
              { "data": "partNumber" },
              { "data": "revision" },
              { "data": "quantity" },

            ]

            let columns = [
              {
                name: "Id",
                alignInColumn: "left",

              },
              {
                name: this.lang.table_header_PartNumber,
                alignInColumn: "left",

              },
              {
                name: this.lang.table_header_Revision,
                alignInColumn: "left",

              },
              {
                name: this.lang.table_header_Quantity,
                alignInColumn: "left",

              },

            ]

            var header = "";
            var columnDefs = [];
            var len = columns.length;
            let trigSymbol = false;
            let trigHDLSymbol = false;
            let trigFootprint = false;
            for (var i = 0; i < len; i++){

              let classname = '_dt-body-'+ columns[i].alignInColumn;

              let  el = {
                  targets: i,
                  className: classname,
                  render: function ( data, type, row, meta ) {
                    if (data == null) {
                      data = "";
                    }

                    data = $.fn.dataTable.render.text().display(data);
                    if (data.display != undefined) {
                      data.display = $.fn.dataTable.render.text().display(data.display);
                    }

                    if (meta.col == 0){
                      return data;
                    }
                    if (meta.col == 1) {

                      if (row.isMain == true) {
                        return data + " (Main)";
                      }
                      return data;
                    }
                    
                    
                    return data;
                  }
                }

                columnDefs.push(el);


              var th = document.createElement("th");
              tr.appendChild(th);
              var br = document.createElement("br");
              th.appendChild(br);

              var tx = document.createTextNode(columns[i].name)
              th.appendChild(tx);

            }


            var json = {};
            json.paging = false;
            json.info = false;
            json.dom = 'f<t>';
            json.data= _dataTable;
            json.myColumnFormats = columns;
            json.select = true;
            json.columns = cols;
            json.columnDefs = columnDefs;
            json.order = [1, "asc"];
            json.initComplete = function () {


            
            
          }
            

            if ($.fn.dataTable.isDataTable("#t_"+this.idAssembly)) {
                this.mainTable.destroy();
                
            }



            this.mainTable = $('#t_'+this.idAssembly).DataTable(json);


            this.mainTable.columns.adjust().draw();

            //hide first column in table
            this.mainTable.column( 0 ).visible( false );
            //this.mainTable.column( 1 ).visible( false );

            let _mainTable = this.mainTable;

            //search input change view
            var searchplace = document.getElementById("t_" + this.idAssembly + "_filter").firstChild

            while (searchplace.firstChild) {

              if (searchplace.firstChild.textContent == "Search:"){
                  searchplace.removeChild(searchplace.firstChild);
                  break;
              }

            }

            searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
            searchplace.firstChild.setAttribute("class", "form-control form-control-sm")

            $("#t_" + this.idAssembly + " tbody").on('dblclick', 'tr', function () {


              let rowData = _mainTable.rows(this._DT_RowIndex).data();
              
              _vue.goTo(rowData[0]);



            });

            
            
            

          },
          generateSVG(elements, type){
            var _vue = this;
            this.$store.dispatch("showLoader", {visible: true, text: "wait"});
            const elementsArray = elements.split(",");

            
            let jsonString = ""
            
            for (let i = 0, lei = elementsArray.length; i < lei; i++){

              
              
              //test###########
              // console.log(elementsArray[i])
              // var svgStr = Json2Svg.create(JSON.parse(jsonString), 400, 400);
              // console.log(svgStr)
              //##############
              

              this.generateLocalSvg(elementsArray[i], type)
              .then(function(resp){
                let svgStr = resp.svg;
                
                  const blob = new Blob([svgStr], {type: 'image/svg+xml'});
                  const file = new File([blob], resp.actualName+'.svg')
                  //send to api
                  const objFile = {
                    type: type, //type of library
                    file: file //file name is a name of library
                  };
                  // if (_vue.appConf.status.isLM===true){

                  //       objFile.revisionId = _vue.lockedRevisionId;
                  //       console.log(objFile)
                  //       return _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_importImage", objFile)
                  //           .then((result)=>{
                              
                  //             result = JSON.parse(result);
                  //             console.log(result);
                              
                  //             let obj = {};
                  //             if (result.data != undefined){
                  //               if (result.data == 1){
                  //                 obj = {
                  //                   text: _vue.lang.alert_success_create_image,
                  //                   time: 10,
                  //                   type: "success"
                  //                 }
                  //               }else{
                  //                 obj = {
                  //                   text: _vue.lang.alert_error_create_image,
                  //                   time: 15,
                  //                   type: "danger"
                  //                 }
                  //               }
                  //             }else{
                                
                  //               let err = "";
                  //               if (result.message != undefined){
                  //                 err = ": " + result.message;
                  //               }
                  //               obj = {
                  //                 text: _vue.lang.alert_error_create_image + err,
                  //                 time: 15,
                  //                 type: "danger"
                  //               }
                  //             }
                  //             _vue.$store.dispatch("displayFooterAlert", obj);
                              
                              
                              
                  //           });
                  // } else {
                    return _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_uploadSvg", objFile)
                        .then((result)=>{
                          result = JSON.parse(result);
                              console.log(result);
                              
                              let obj = {};
                              if (result.data != undefined){
                                if (result.data == 1){
                                  obj = {
                                    text: _vue.lang.alert_success_create_image,
                                    time: 10,
                                    type: "success"
                                  }


                                  const reloadObj = {
                                      status: true,
                                      name: "QuickViewTableComponent"
                                  }
                                  _vue.$store.dispatch("reloadAfterAction", reloadObj);
                                }else{
                                  obj = {
                                    text: _vue.lang.alert_error_create_image,
                                    time: 15,
                                    type: "danger"
                                  }
                                }
                              }else{
                                
                                let err = "";
                                if (result.message != undefined){
                                  err = ": " + result.message;
                                }
                                obj = {
                                  text: _vue.lang.alert_error_create_image + err,
                                  time: 15,
                                  type: "danger"
                                }
                              }
                              _vue.$store.dispatch("displayFooterAlert", obj);
                       });
                  //}
                  
              })

              


              

              

            }

            
          },
          generateLocalSvg(symbolName, type) {
              let vue = this;
              
              
            if (type == "symbol"){
                return tclAPI.makeSymbolSVG(symbolName)
                  .then(function (resp) {
                    
                    
                    let errorsList = JSON.parse(resp.errors);
                    let json = JSON.parse(resp.json);
                    
                    if (resp.json == "") {

                      

                      return $.Deferred().reject(errorsList).promise();
                    }
                    let jsonString = JSON.parse(resp.json);
                    
                    var svgStr = Json2Svg.create(jsonString, 400, 400);
                    return $.Deferred().resolve({svg:svgStr, actualName:resp.actualName}).promise();
                  })
                  .then(null, function (err) {
                    
                    console.warn(err);
                      let obj = {
                        text: "alert_error_create_image: " + err,
                        time: 15,
                        type: "danger"
                      }

                      vue.$store.dispatch("displayFooterAlert", obj);
                      

                      return $.Deferred().reject(err).promise();
                  })
                  .always(function() {
                    vue.$store.dispatch("showLoader", {visible: false});
                    
                  });
              }
            if (type == LibraryTypes.FOOTPRINT || type == LibraryTypes.MECHANICAL){
                return tclAPI.makeFootprintSVG(symbolName)
                  .then(function (resp) {
                    
                    let errorsList = JSON.parse(resp.errors);
                    
                    
                    if (resp.svg == "") {
                      return $.Deferred().reject(errorsList).promise();
                    }
                    //let jsonString = JSON.parse(resp.svg);
                    
                    //var svgStr = Json2Svg.create(jsonString, 400, 400);
                    return $.Deferred().resolve({svg:resp.svg, json:resp.json, actualName:resp.actualName}).promise();
                  })
                  .then(null, function (err) {
                    
                    
                    console.warn(err);
                    let obj = {
                      text: "alert_error_create_image: " + err,
                      time: 15,
                      type: "danger"
                    }

                    vue.$store.dispatch("displayFooterAlert", obj);
                    

                    return $.Deferred().reject(err).promise();
                  })
                  .always(function() {
                    vue.$store.dispatch("showLoader", {visible: false});
                    
                  });
              }
              

          },
          goTo(goalObj) {
            


            let from = "/PartManager/PartTable";

            let to = "/PartManager/PartDetails";


            let obj = {
              col___revisionId: {
                revisionId: goalObj.revisionId,
                projectId: goalObj.partId,
                userId: goalObj.userId,
                value: {
                  display: goalObj.revisionId
                }
              },
              col___revision: {
                revisionId: goalObj.revisionId,
                projectId: goalObj.partId,
                value: {
                  display: goalObj.revision
                }
              },
              col___status: {
                revisionId: goalObj.revisionId,
                projectId: goalObj.partId,
                value: {
                  display: ""
                }

              },
              col___name: {
                revisionId: goalObj.revisionId,
                projectId: goalObj.partId,
                value: {
                  display: ""
                }

              },
              col___image: {
                revisionId: goalObj.revisionId,
                projectId: goalObj.partId,
                value: {
                  display: ""
                }
              },
              col___projectType: {
                revisionId: goalObj.revisionId,
                projectId: goalObj.partId,
                value: {
                  display: ""
                }
              }
            }



            this.$store.dispatch("deleteAllSelectedRows");
            this.$store.dispatch("setSelectedRows", [obj]);

            this.$store.dispatch("setOuterData", true);

            this.$store.dispatch("editPropertiesForm", false);




            const query = {
              from: this.$route.path,
              to: to,
              revisionId: goalObj.revisionId,
              id: goalObj.partId,
              //sourceId: this.elementId,
              //sourceRevisionId: this.revisionId,
              end: true
            }
            
            this.$router.push({ path: to, query: query });
          },

        
       }

    }
</script>
<style lang="scss">
  @import "./../../scss/_custom.scss";
.QuickViewTableComponent{
    table{
      font-size: 0.75rem;
      padding: 0px !important;

    }
    table.dataTable{
        width: 100% !important;
        
    }

    table th {
      padding: 2px !important;

    }
    table th select{
      width: 100% !important;

    }
    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;

    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    .dataTables_processing {
      position: absolute;
      top: 20px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }

    .dataTables_filter{
      font-size: 10px;
      float: left;
      width: 210px;
    }
    .searcher{
      float: left;
    }
    .dt-buttons{

      font-size: 0.7rem;
      margin-left: 210px;

    }
    .dataTables_filter .form-control-sm,
    .input-group-sm>.form-control {
      padding: 0.25rem 0.5rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    .red{
      color: $redfont;
    }
    .green{
      color: #247f3e;
    }

    .svg-image{
      background-color: white;
      margin: 10px;
      border: 1px solid #cccccc;
    }
    hr{
      margin-top: 5px;
      margin-bottom: 5px;
    }
    .img-thumbnail{
      max-width: 200px;
      max-height: 200px;
    
      margin-top: 3px;
      margin-bottom: 3px;
    }
    .image-symbol{
      background-color: #ffffff;
      border: 1px solid #dee2e6;
      border-radius: 0.25rem;
      margin-bottom: 3px;
      overflow: hidden;
      width: 200px;
      height: 200px;
      display: block;
      
    }
    .image-footprint{
      background-color: #ffffff;
      //border: 1px solid #dee2e6;
      border-radius: 0.25rem;
      margin-top: 3px;
      margin-bottom: 5px;
      margin-left: 2px;
      overflow: hidden;
      width: 200px;
      height: 200px;
      
    }
    .image-zoom {
      cursor: zoom-in;
    }
    svg{
      display: block;
      width: 200px;
      height: 200px;
      overflow: hidden;
      
    }
    .bar-symbol{
      margin-top: 5px;
      margin-bottom: 5px;
      margin-left: 0px;
      width: 200px;
    }
    .symbol_select{
      padding: 1px;
      margin-top: 3px;
      
    }
    .hdlsymbol_select{
      padding: 1px;
      margin-top: 3px;
      
    }
    .library-table{
      margin-left:3px;
      margin-right: 5px;
      margin-bottom: 5px;
      width: 99%;
    }
    .btn{
      margin-left: 0px !important;
      height: 26.8px !important;
    }
    .input-viewer{
      width: 110px !important;
      
    }
    .btn-bar {
      height: 26.8px !important;
    }
    .checkboxPinOption{
      margin-left: 0px;
      margin-bottom: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/QuickViewTableComponent.vue